export { default as AuthInput, default } from './AuthInput';
